import type { CreateOwnerInput } from '@chukua/common';
import { useState } from 'react';
import { useToast } from '../../lib/use-toast';
import { createOwner } from './owners.api';
import { useOwnerList } from './use-owner-list';

/** The owners list (`useOwnerList`) plus create — a form failure stays inline (CLAUDE.md → Web conventions). */
export function useOwners() {
  const { state, list, isRefreshing, reload } = useOwnerList();
  const [createError, setCreateError] = useState<string | null>(null);
  const [creating, setCreating] = useState(false);
  const toast = useToast();

  async function create(input: CreateOwnerInput): Promise<boolean> {
    setCreateError(null);
    setCreating(true);
    try {
      await createOwner(input);
      await reload();
      toast.success(`${input.name} created`);
      return true;
    } catch {
      setCreateError('Could not create the owner — check the fields and try again.');
      return false;
    } finally {
      setCreating(false);
    }
  }

  return { state, list, isRefreshing, createError, creating, create, resetCreateError: () => setCreateError(null) };
}
